<template>
  <div class="page welfare-history">
        
    <navigation>历史福利
      <div slot="right" class="quan" @click="toQuanList">查看券包</div>
    </navigation>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="top">
          <img v-if="item.activeType === 'NEW_PERSON'" src="./images/img_xinren02.png" alt="图片" class="type">
          <img v-else-if="item.activeType === 'REDUCTION_INTEREST'" src="./images/img_mianxi02@2x.png" alt="图片" class="type">
          <div class="packet-wrapper">
            <img src="./images/icon_xianjinhongbao02@2x.png" alt="" class="packet">
            <div v-if="item.activeType === 'NEW_PERSON'" class="count">现金红包 X 1</div>
            <div v-else class="count">免息红包 X 1</div>
          </div>
        </div>
        <img v-if="item.couponStatus === 'USED'" src="./images/icon_shiyong.png" alt="" class="status-image">
        <img v-else-if="item.couponStatus === 'TIMEOUT'" src="./images/icon_guoqi.png" alt="" class="status-image">

        <welfare-step :history="true" :index='item.index' :type='item.type' class="welfare-step">
                
        </welfare-step>
      </div>
    </div>
    <section v-if="list.length === 0" class="no-data">
      <img src="../quan/images/quan_empty.png">
      <div class="tips">这里空空如也...</div>
      <div class="sub-tips">积累更多信用，赚取更多优惠吧</div>
    </section>
    <div class="footer">
      活动最终解释权归天美贷所有
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import welfareStep from './compents/welfare-step.vue'
export default {
  name: 'welfare-history',
  customReadyNotify: true,
  components: {
    welfareStep
  },

  async created () {
    await this.getWelfareHistoryList()
    this.$bus.$emit('ready')
  },

  data () {
    return {
      list: [
      ]
    }
  },

  methods: {
    ...mapActions('activities', ['getWelfareHistoryListX']),
    async getWelfareHistoryList () {
      const response = await this.getWelfareHistoryListX({})
      if (response.data) {
        this.list = response.data.map(function (item) {
          let i = item
          i.type = item.activeType
          if (item.activeType === 'REDUCTION_INTEREST') {
            if (['OCR', 'INFO', 'LIVENSS', 'CREDIT', 'CREDIT_REVIEW', 'CREDIT_LOCKED'].includes(item.currentStep)) {
              i.index = 0
            } else if (['CREDIT_SUCCESS', 'LOAN', 'LOAN_LOCKED'].includes(item.currentStep)) {
              i.index = 1
            } else if (['LOANING', 'LOAN_PASSED'].includes(item.currentStep)) {
              i.index = 2
            } else if (['FINAL'].includes(item.currentStep)) {
              i.index = 3
            }
          } else {
            if (['OCR', 'INFO', 'LIVENSS', 'CREDIT', 'CREDIT_REVIEW', 'CREDIT_SUCCESS', 'CREDIT_LOCKED', 'LOAN_LOCKED', 'LOAN', 'LOANING'].includes(item.currentStep)) {
              i.index = 1
            } else if (['LOAN_PASSED'].includes(item.currentStep)) {
              i.index = 2
            } else if (['FINAL'].includes(item.currentStep)) {
              i.index = 3
            }
          }
          return i
        })
      }
    },
    toQuanList () {
      this.$router.push('/quan/history')
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.page.welfare-history {
  background: #FAFAFA;
  .nd-navigation {
    .center {
      margin-right: 0px;
    }
    .right {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
    }
  }
  .list {
    position: relative;
    padding: 0px 34px;
    padding-bottom: 180px;
    .item {
      padding-right: 27px;
      margin-top: 34px;
      height: 220px;
      background: #ffffff;
      border-radius: 20px;
      .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .type {
          width: 170px;
          height: 46px
        }
        .packet-wrapper {
          margin-top: 15px;
          display: flex;
          .packet {
            filter: grayscale(1);
            margin-right: 10px;
            width: 35px;
            height: 36px;
          }
          .count {
            
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
          }
        }
      }
      .status-image {
        z-index: 10;
        position: absolute;
        right: 62px;
        width: 160px;
        height: 140px;
      }
      
      .welfare-step {
          margin-top: 57px;
          height: 60px;
      }
    }
  }

  .no-data {
      width: 100%;
      text-align: center;
      img {
          width: 205px;
          height: 173px;
          margin-top: 263px;
          // margin-left: 173px;
      }

      .tips {
          font-size:28px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(102,102,102,1);
          line-height:36px;
          margin-top: 37px;
      }
      .sub-tips {
        font-size:24px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:36px;
          margin-top: 5px;
      }
  }
  .footer {
    width: 750px;
    margin-left: -375px;
    height: 160px;
    position: fixed;
    bottom: 0;
    left: 50%;
    height: 120px;
    text-align: center;
    margin-top: 50px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #CCCCCC;
    line-height: 30px;
    padding-bottom: 50px;
  }
}
</style>
